import { render, staticRenderFns } from "./eventPlayers.vue?vue&type=template&id=61ad123c&scoped=true"
import script from "./eventPlayers.vue?vue&type=script&lang=js"
export * from "./eventPlayers.vue?vue&type=script&lang=js"
import style0 from "./eventPlayers.vue?vue&type=style&index=0&id=61ad123c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ad123c",
  null
  
)

export default component.exports